
const INITIAL_STATE = {
    isAuthenticated: false,
    user: null,
    authtoken: null,
    networkStatus: true

};

const UserReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'ADD_USER':
            return {
                ...state,
                user: action.payload.user,
                isAuthenticated: action.payload.isAuthenticated,
                authtoken: action.payload.authtoken
            };
        case 'NETWORK_CHECK':
            return {
                ...state,
                networkStatus: action.payload.networkStatus,
            };

        default:
            return state;
    }
};

export default UserReducer;
